// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
/**
 * Deterministic per-author colours. A stable hue is derived from the author id
 * so the same person keeps the same colour across everyone's screens without any
 * coordination. Pure and unit-tested.
 */

/** FNV-1a 32-bit hash of a string → an integer. */
export function hashString(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** A stable hue in [0, 360) for an author id. */
export function hueForId(id: string): number {
  return hashString(id) % 360;
}
